var React = require('react');

function Briefcase (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/Briefcase"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("path",{"d":"M8,9 L8,7 C8,5.8954305 8.8954305,5 10,5 L15,5 C16.1045695,5 17,5.8954305 17,7 L17,9 L19,9 C19.5522847,9 20,9.44771525 20,10 L20,18 C20,18.5522847 19.5522847,19 19,19 L6,19 C5.44771525,19 5,18.5522847 5,18 L5,10 C5,9.44771525 5.44771525,9 6,9 L8,9 Z M10.5,7 C10.2238576,7 10,7.22385763 10,7.5 L10,9 L15,9 L15,7.5 C15,7.22385763 14.7761424,7 14.5,7 L10.5,7 Z","fill":"currentColor","key":2})]);
}

Briefcase.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = Briefcase;

Briefcase.default = Briefcase;
